import { render } from "./2019-07-16-Miniprogram Plugin.md?vue&type=template&id=b6825830"
const script = {}
script.render = render

export default script